import { Outlet } from "react-router";

const Section = () => {
  return (
      <Outlet />
  );
};

export default Section;
